import type { EntityConfig } from '../types'

export const organizationEntity: EntityConfig = {
  id: 'organization',
  displayName: 'Organization',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'pending_approval', label: 'Pending Approval' },
      { value: 'onboarding', label: 'Onboarding' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'suspended', label: 'Suspended', color: 'error' },
      { value: 'pending_approval', label: 'Pending Approval', color: 'warning' },
      { value: 'onboarding', label: 'Onboarding', color: 'info' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      inactive: ['inactive'],
      suspended: ['suspended'],
      pending_approval: ['pending_approval'],
      onboarding: ['onboarding'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    country: { type: 'string_array', urlKey: 'country' },
    type: { type: 'string_array', urlKey: 'type' },
    parentBank: { type: 'string_array', urlKey: 'parentBank' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
  ]
}
